<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "ProcessActionLayout"
    }
</script>

<style scoped>

</style>